import { AxiosPromise } from "axios";
import { EnvironmentFactory } from "src/factory/EnvironmentFactory/environment.factory";
import { Util } from "src/utils/Util";
import { IStatusTypesData } from "../interfaces/IStatusTypesData";
import { IClaimStatesData } from "../interfaces/IClaimStatesData";
import { IClaimStateByPostalCodeData } from "../interfaces/IClaimStateByPostalCodeData";
import { IClaimFormRequest } from "../interfaces/IClaimFormRequest";
import { IClaimPersonData } from "../interfaces/IClaimPersonData";
import { IClaimPersonInfoUpdateRequest } from "../interfaces/IClaimPersonInfoUpdateRequest";
import { IClaimPictureData } from "../interfaces/IClaimPictureData";
import { IClaimAdjusterData } from "../interfaces/IClaimAdjusterData";
import { IClaimServiceTypesRequest } from "../interfaces/IClaimServiceTypesRequest";
import { IClaimAdjusterInfoUpdateRequest } from "../interfaces/IClaimAdjusterInfoUpdateRequest";
import { IClaimProvidersRequest } from "../interfaces/IClaimProvidersRequest";
import { ICoveragesListRequest } from "../interfaces/ICoveragesListRequest";
import { IProvidersListData } from "../interfaces/IProvidersListData";

/**
 *
 */
export namespace ClaimRegisterService {

  /**
   * 
   * @returns 
   */
  export const statusTypeService = (typeId: string, params?: IClaimServiceTypesRequest): AxiosPromise<IStatusTypesData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_STATUS_TYPE(typeId), { params: params });
  }

	/**
	 * 
	 * @param serviceType 
	 * @returns 
	 */
	export const categoriesListService = (serviceType: string): AxiosPromise<IStatusTypesData> => {
		return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIMS_CATEGORIES_LIST(serviceType));
	}
	
	/**
   * 
   * @returns 
   */
	export const coveragesTypeService = (params: ICoveragesListRequest): AxiosPromise<IStatusTypesData> => {
		return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIMS_STATUS, { params: params });
	}

  /**
   * 
   * @returns 
   */
	export const causesListService = (): AxiosPromise<IStatusTypesData> => {
		return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_STATUS_CAUSE);
	}

	/**
	 * 
	 * @param serviceType 
	 * @param category 
	 * @returns 
	 */
	export const providersListService = (params: IClaimProvidersRequest): AxiosPromise<IProvidersListData> => {
		return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIMS_PROVIDERS, { params: params });
	}

  /**
   * 
   * @returns 
   */
  export const countryStatesService = (): AxiosPromise<IClaimStatesData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_STATES);
  }

  /**
   * 
   * @returns 
   */
  export const countryStateByPostalCodeService = (postalCode: string): AxiosPromise<IClaimStateByPostalCodeData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_STATES_BY_POSTAL_CODE(postalCode));
  }

  /**
   * 
   * @returns 
   */
  export const claimPersonInfoUpdateService = (request: IClaimPersonInfoUpdateRequest): AxiosPromise<IClaimPersonData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).put(Util.API_PATH.CLAIM_PERSON_INFO(), request);
  }

  /**
   * 
   * @returns 
   */
  export const claimAdjusterInfoUpdateService = (request: IClaimAdjusterInfoUpdateRequest): AxiosPromise<IClaimAdjusterData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).put(Util.API_PATH.CLAIM_ADJUSTER_INFO(), request);
  }

  /**
   * 
   * @returns 
   */
  export const claimPictureService = (request: FormData): AxiosPromise<IClaimPictureData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).post(Util.API_PATH.CLAIM_PICTURES, request);
  }


  /**
   * 
   * @returns 
   */
  export const claimPersonInfoService = (request: IClaimFormRequest): AxiosPromise<IClaimPersonData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_PERSON_INFO(request.id, request.key));
  }

  /**
   * 
   * @returns 
   */
  export const claimAdjusterInfoService = (request: IClaimFormRequest): AxiosPromise<IClaimAdjusterData> => {
    return EnvironmentFactory.Http.PublicHttp(EnvironmentFactory.ENV_DOMAIN_NAMES.DEFENDER_API).get(Util.API_PATH.CLAIM_ADJUSTER_INFO(request.id, request.key) );
  }
}